import React, { useEffect, useState } from "react";
import { api, apiErr } from "../../lib/api";
import { Badge } from "../../components/ui/badge";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "../../components/ui/table";
import { toast } from "sonner";
import { PageShell } from "./PageShell";

const ACTION_VARIANT = {
  tenant_suspended: "destructive", tenant_reactivated: "success",
  user_mfa_reset: "warning", user_password_reset: "warning", announcement_sent: "outline",
};

export default function PlatformAudit() {
  const [entries, setEntries] = useState(null);
  useEffect(() => {
    api.get("/platform/audit").then((r) => setEntries(r.data.entries)).catch((e) => toast.error(apiErr(e)));
  }, []);
  return (
    <PageShell title="Operator Audit Log" testid="platform-audit-page"
      subtitle="Every platform-operator action — suspensions, account rescues, announcements — is recorded here permanently.">
      <div className="card-flat overflow-x-auto">
        <Table>
          <TableHeader><TableRow>
            <TableHead>When</TableHead><TableHead>Operator</TableHead><TableHead>Action</TableHead>
            <TableHead>Target</TableHead><TableHead>Detail</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {(entries || []).map((a) => (
              <TableRow key={a.id} data-testid="audit-row">
                <TableCell className="font-mono text-xs whitespace-nowrap">{new Date(a.at).toLocaleString("en-SG", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}</TableCell>
                <TableCell className="font-mono text-xs">{a.by}</TableCell>
                <TableCell><Badge variant={ACTION_VARIANT[a.action] || "outline"} className="text-[9px] uppercase">{a.action.replace(/_/g, " ")}</Badge></TableCell>
                <TableCell className="text-sm">{a.target || "—"}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{a.detail || "—"}</TableCell>
              </TableRow>
            ))}
            {entries && !entries.length && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-8 text-sm">No operator actions recorded yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </PageShell>
  );
}
